<template>
  <div class="niste-clan">
    <div>Niste član ovog predmeta. Javite se nositelju tima da vam omogući pristup.</div>
    <router-link to="/cases">Povrat na popis</router-link>
  </div>
</template>

<script>
export default {
    

}
</script>

<style>

</style>